(() => {
  const initialize = () => document.querySelectorAll('[data-po1-premium]').forEach(section => {
    if (section.dataset.initialized) return;
    section.dataset.initialized = 'true';
    const strings = JSON.parse(section.querySelector('[data-premium-strings]').textContent);
    const count = section.querySelectorAll('[data-premium-card]').length;
    document.querySelectorAll('a[href="#bf-premium"] span').forEach(element => { element.textContent = String(count); });
    if (Date.now() >= Date.parse(section.dataset.updatesEnd)) {
      const banner = section.querySelector('[data-premium-banner]');
      if (banner) banner.hidden = true;
      section.querySelector('[data-premium-updates]').textContent = strings.updatesEnded;
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize); else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
